module.exports = __webpack_public_path__ + "img/99-icon-fcuk.568a7ea6.svg";